require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-gift-from-ball-state-financial-will-boost-universitys-financial-literacy.json") })
        }
      }, "path---articles-gift-from-ball-state-financial-will-boost-universitys-financial-literacy");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-gift-from-ball-state-financial-will-boost-universitys-financial-literacy!./.cache/json/articles-gift-from-ball-state-financial-will-boost-universitys-financial-literacy.json
// module id = 1695
// module chunks = 231608221292675